import { render, staticRenderFns } from "./WipQiDetailsForm.vue?vue&type=template&id=cc1e4222&scoped=true&"
import script from "./WipQiDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./WipQiDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./WipQiDetailsForm.vue?vue&type=style&index=0&id=cc1e4222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1e4222",
  null
  
)

export default component.exports